import {
  faArrowDown91,
  faArrowDownAZ,
  faArrowUp19,
  faArrowUpZA,
} from "@fortawesome/sharp-regular-svg-icons";
import ToggleButton from "@mui/material/ToggleButton";

import { DriveSortField } from "../../features/drive/types";
import { Icon, useTheme } from "../ui-v2";

export type SortDirection = "asc" | "desc";

export const SortDirectionToggle = ({
  value,
  sortField = "created_at",
  onChange,
}: {
  value: SortDirection;
  sortField?: DriveSortField;
  onChange: (value: SortDirection) => void;
}) => {
  const theme = useTheme();
  const { palette, spacing } = theme;

  return (
    <ToggleButton
      value={value}
      onChange={() => onChange(value === "asc" ? "desc" : "asc")}
      aria-label={value === "asc" ? "Sort ascending" : "Sort descending"}
      sx={{
        height: spacing(7),
        width: spacing(7),
        padding: 0,
        borderRadius: spacing(1),
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0,
        background: "transparent",
        border: `1px solid ${palette.secondary[6]}`,
        color: "secondary.2",
        "&:hover": {
          borderColor: palette.secondary[5],
          background: palette.secondary[7],
          position: "relative",
          zIndex: 1,
        },
      }}
    >
      {sortField === "created_at" ? (
        <Icon icon={value === "asc" ? faArrowDown91 : faArrowUp19} />
      ) : (
        <Icon icon={value === "asc" ? faArrowDownAZ : faArrowUpZA} />
      )}
    </ToggleButton>
  );
};
